/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AgencyAsFreelancerResource } from './';
import {
    AgencyAsFreelancerResourceFromJSON,
    AgencyAsFreelancerResourceFromJSONTyped,
    AgencyAsFreelancerResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyAsFreelancerPageResource
 */
export interface AgencyAsFreelancerPageResource {
    /**
     * 
     * @type {Array<AgencyAsFreelancerResource>}
     * @memberof AgencyAsFreelancerPageResource
     */
    items: Array<AgencyAsFreelancerResource>;
    /**
     * 
     * @type {number}
     * @memberof AgencyAsFreelancerPageResource
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyAsFreelancerPageResource
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyAsFreelancerPageResource
     */
    hasNext: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyAsFreelancerPageResource
     */
    hasPrevious: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgencyAsFreelancerPageResource
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyAsFreelancerPageResource
     */
    pageSize: number;
}

/**
 * Check if a given object implements the AgencyAsFreelancerPageResource interface.
 */
export function instanceOfAgencyAsFreelancerPageResource(value: object): value is AgencyAsFreelancerPageResource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('hasNext' in value) || value['hasNext'] === undefined) return false;
    if (!('hasPrevious' in value) || value['hasPrevious'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function AgencyAsFreelancerPageResourceFromJSON(json: any): AgencyAsFreelancerPageResource {
    return AgencyAsFreelancerPageResourceFromJSONTyped(json, false);
}

export function AgencyAsFreelancerPageResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyAsFreelancerPageResource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AgencyAsFreelancerResourceFromJSON)),
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
        'hasNext': json['hasNext'],
        'hasPrevious': json['hasPrevious'],
        'page': json['page'],
        'pageSize': json['pageSize'],
    };
}

export function AgencyAsFreelancerPageResourceToJSON(value?: AgencyAsFreelancerPageResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => AgencyAsFreelancerResourceToJSON(v))),
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
        'hasNext': value['hasNext'],
        'hasPrevious': value['hasPrevious'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

